import type { BLOCK_TYPE } from '../enums'

import type { IBlock, BlockBaseSettings } from './base'

export type ImageDimension = {
  /** Original image width, in pixels */
  width?: number
  /** Original image height, in pixels */
  height?: number
}

export enum IMAGE_WIDTH {
  FULL_WIDTH = '100%',
  HALF_WIDTH = '50%',
  THIRTY_PERCENT = '30%'
}

export interface ImageBlock extends IBlock {
  type: BLOCK_TYPE.IMAGE
  required: false
  settings: BlockBaseSettings & {
    /**
     * Alternate text for the image
     *
     * Used to meet accessibility requirements
     */
    altText?: string | null
    /** Original image URL, used to render the image */
    url: string
    /**
     * Original image dimensions
     *
     * Currently used to calculate the aspect ratio and render placeholders that help prevent
     * CLS (Cumulative Layout Shift) when the image is finally loaded.
     *
     * WARNING: Only recently uploaded images should always contain this information
     */
    dimension?: ImageDimension
    /** Rendered image width relative to the "zone" which contains it */
    width: IMAGE_WIDTH
  }
}
